<template>
  <div class="ag-cell-date-renderer">
    {{ value }}
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ICellRendererParams } from 'ag-grid-community';

export default defineComponent({
  name: 'DateRenderer',

  props: {
    params: {
      type: Object as PropType<
        ICellRendererParams<any, string> & {
          placeholder: string;
        }
      >,
      required: true,
    },
  },

  computed: {
    value(): string {
      if (this.params.value) {
        return this.$d(new Date(this.params.value), 'short');
      }

      if (this.params.placeholder) {
        return this.$t(this.params.placeholder);
      }

      return '';
    },
  },
});
</script>
